import { Descriptions, Divider, Drawer } from "antd";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function StateAgencyView({ onClose, open, prodd }) {
  const navigate = useNavigate();

  const items1 = [
    {
      key: "1",
      label: "Insititution Name",
      children: prodd?.agencyName ?? "N/A",
    },
    {
      key: "5",
      label: "Office Phone Number",
      children: prodd?.agencyOfficePhone ?? "N/A",
    },
    {
      key: "2",
      label: "Official Email",
      children: prodd?.agencyOfficialEmail ?? "N/A",
    },
    {
      key: "3",
      label: "MD/CEO Name",
      children: prodd?.agencyMdOrCeoName ?? "N/A",
    }, 
    {
      key: "6",
      label: "Created Date",
      children: (
        <div>
          {prodd?.createdDate
            ? moment(prodd?.createdDate)?.format("DD-MM-YYYY HH:mm:ss")
            : "--"}
        </div>
      ),
    },
  ];
  const items2 = [
    {
      key: "1",
      label: "Physical Location",
      children: prodd?.agencyPhysicalLocation ?? "N/A",
    },
    {
      key: "5",
      label: "Street",
      children: prodd?.agencyStreet ?? "N/A",
    },
    {
      key: "2",
      label: "Building",
      children: prodd?.agencyBuilding ?? "N/A",
    },
    {
      key: "3",
      label: "City",
      children: prodd?.agencyCity ?? "N/A",
    },
    {
      key: "4",
      label: "Secretariat",
      children: prodd?.agencySecretariat ?? "N/A",
    },
    
  ];
  const items3 = [
    {
      key: "1",
      label: "Name",
      children: prodd?.agencyContactPersonName ?? "N/A",
    },

    {
      key: "2",
      label: "Phone",
      children: prodd?.agencyContactPersonPhone ?? "N/A",
    },
    {
      key: "3",
      label: "ID Number",
      children: prodd?.agencyContactPersonIdNumber ?? "N/A",
    },
    {
      key: "4",
      label: "Admin Email",
      children: prodd?.agencyContactPersonEmail ?? "N/A",
    },
  ];
  return (
    <Drawer width={800} title="Basic Drawer" open={open} onClose={onClose}>
      <div className="flex justify-between items-center">
        <div className="details_h">State Agency information</div>
      </div>

      <div className="mt-[1rem]">
        <Divider />
      </div>
      <div className="w-full mt-[2.75rem] flex">
        <Descriptions
          title="Information"
          column={1}
          colon={false}
          items={items1}
          layout="vertical"
        />
        <Descriptions
          title="Location"
          column={1}
          colon={false}
          items={items2}
          layout="vertical"
        />
        <Descriptions
          title="Contact Person"
          column={1}
          colon={false}
          items={items3}
          layout="vertical"
        />
      </div>
    </Drawer>
  );
}

export default StateAgencyView;
